module.exports = __webpack_public_path__ + "static/media/Icon_Technology3.9359e59d.svg";